import React, { Suspense, lazy, useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';

const GoLanding = lazy(() => import('./pages/GoLanding'));
const GoProduct = lazy(() => import('./pages/GoProduct'));
const GoSuccessPage = lazy(() => import('./pages/GoSuccessPage'));

const TermsAndConditions = lazy(() => import('../../pages/TermsAndConditions'));
const ContactPage = lazy(() => import('../../pages/ContactPage'));
const PrivacyPolicy = lazy(() => import('../../pages/PrivacyPolicy'));

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function FunnelGo({ basePath }) {
  return (
    <div className="go-funnel">
    <Suspense fallback={<div>Loading...</div>}>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<GoLanding basePath={basePath} />} />
        <Route path="/product" element={<GoProduct basePath={basePath} />} />
        <Route path="/success" element={<GoSuccessPage />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
    </Suspense>
    </div>
  );
}

export default FunnelGo;
